module.exports = __webpack_public_path__ + "img/f.a2286ce3.jpg";